import { render, staticRenderFns } from "./RegisterPage.vue?vue&type=template&id=4c155740&scoped=true"
import script from "./RegisterPage.js?vue&type=script&lang=js&external"
export * from "./RegisterPage.js?vue&type=script&lang=js&external"
import style0 from "./RegisterPage.vue?vue&type=style&index=0&id=4c155740&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c155740",
  null
  
)

export default component.exports